<template>
  <div class="login-wrapper">
    <el-image :src="require('@/img/logo.png')" class="login-logo" />

    <el-form
      :model="ruleForm"
      v-if="!hasClients"
      status-icon
      :rules="rules"
      size="medium"
      ref="ruleForm"
      label-width="0"
    >
      <div class="page-title" v-html="$t('login_title')"></div>
      <el-form-item prop="username">
        <el-input
          type="text"
          :placeholder="$t('username')"
          v-model="ruleForm.username"
          @keyup.enter="submitForm('ruleForm')"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          type="password"
          :placeholder="$t('password')"
          v-model="ruleForm.password"
          @keyup.enter="submitForm('ruleForm')"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="errors != ''">
        <el-alert :title="errors" type="error"> </el-alert>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">{{
          $t("login")
        }}</el-button>
      </el-form-item>
    </el-form>

    <el-form
      :model="ruleFormClients"
      v-if="hasClients"
      status-icon
      :rules="rulesClients"
      size="medium"
      ref="ruleFormClients"
      label-width="0"
    >
      <div class="page-title" v-html="$t('select_client')"></div>
      <el-form-item prop="client">
        <el-select
          v-model="ruleFormClients.client"
          :placeholder="$t('please_choose')"
        >
          <el-option
            v-for="c in clients"
            :key="c.idmandate"
            :label="c.name"
            :value="c.idmandate"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="client-actions">
        <el-button type="danger" class="client" round @click="cancel()">{{
          $t("cancel")
        }}</el-button>

        <el-button type="primary" @click="selectClient('ruleFormClients')">{{
          $t("continue")
        }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<style lang="scss">
.login-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  height: 100%;

  @media screen and(max-width: 767px) {
    padding: 24px;
  }

  .login-logo {
    width: 100%;
    max-width: 603px;
  }

  .login {
    display: flex;
    flex-direction: column;
    width: 300px;
    padding: 10px;

    @media screen and(max-width: 767px) {
      width: 100%;
    }
  }

  .page-title {
    text-align: center;
    color: #ffffff;
    font-size: 25px;
    margin-bottom: 48px;
  }

  .el-form {
    width: 400px;

    @media screen and(max-width: 767px) {
      width: 100%;
    }

    .el-form-item__error {
      color: rgb(112, 0, 0) !important;
    }

    .el-button:not(.client) {
      width: 100%;
      text-align: center;
      border-radius: 13px;
      background-color: $gkt-orange;
      border: 0;
      box-shadow: 10px 10px 30px #c46d08;
      position: relative;
      margin-top: 12px;
      transition: background-color 0.25s ease-in-out;

      &:hover,
      &:focus {
        background-color: lighten($gkt-orange, 2);
        transition: background-color 0.25s ease-in-out;
      }

      &::before {
        position: absolute;
        content: "";
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        border-radius: 13px;
        box-shadow: -10px -10px 30px rgba(245, 154, 63, 0.87);
      }
    }

    .el-select {
      display: flex;
      justify-content: center;
    }

    .client-actions {
      display: flex;
      justify-content: space-between;

      .el-button {
        width: auto;
        flex: 1;
      }
    }

    ::-webkit-input-placeholder {
      text-align: center;
      color: $gkt-grey;
    }

    input {
      text-align: center;
      border-radius: 24px !important;
      color: $gkt-grey;
    }

    :-moz-placeholder {
      /* Firefox 18- */
      text-align: center;
      color: $gkt-grey;
    }

    ::-moz-placeholder {
      /* Firefox 19+ */
      text-align: center;
      color: $gkt-grey;
    }

    :-ms-input-placeholder {
      text-align: center;
      color: $gkt-grey;
    }
  }
}
</style>

<script>
export default {
  name: "login",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("enter_password")));
      } else {
        if (this.ruleForm.password !== "") {
          this.$refs.ruleForm.validateField("password");
        }
        callback();
      }
    };

    var validateUsername = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("enter_username")));
      } else {
        if (this.ruleForm.username !== "") {
          this.$refs.ruleForm.validateField("username");
        }
        callback();
      }
    };

    var validateClient = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("select_client_text")));
      } else {
        if (this.ruleFormClients.client !== "") {
          this.$refs.ruleFormClients.validateField("client");
        }
        callback();
      }
    };
    if (this.$root.$i18n.locale == "de") {
      this.$primevue.config.locale.emptyMessage = "Keine Auswahl vorhanden";
    } else {
      this.$primevue.config.locale.emptyMessage = "No available options";
    }

    return {
      hasClients: false,
      clients: [],
      errors: "",
      ruleForm: {
        username: "",
        password: ""
      },
      ruleFormClients: {
        client: ""
      },
      rulesClients: {
        client: [{ validator: validateClient, trigger: "change" }]
      },
      rules: {
        username: [{ validator: validateUsername, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }]
      }
    };
  },
  methods: {
    submitForm(formName) {
      const store = this.$root.store;
      const router = this.$router;

      this.errors = "";

      this.$refs[formName].validate(async valid => {
        if (valid) {
          const response = await store.methods.apiRequest("login", {
            username: this.ruleForm.username,
            password: this.ruleForm.password
          });

          const res = response.data;

          if (res.errordetails) {
            if (res.errordetails == "unrecognized_request") {
              window.location.reload();
              return false;
            }
            this.errors = res.errordetails;
            if (res.errordetails == "login_failed") {
              this.errors = this.$t("login_failed");
            }
          } else {
            if (res.status == "success") {
              store.methods.setCSRFToken(res.csrftoken);
              if (res.mandatelist) {
                this.clients = res.mandatelist;
                this.hasClients = true;
              } else {
                store.methods.setLogin(true);
                store.methods.setCustomerName(this.ruleForm.username);
                store.methods.setLoginType(res.logintype);
                if (res.noticesfield) {
                  store.methods.setNoticesField(res.noticesfield);
                }
                if (res.deleteentries) {
                  store.methods.setDeleteEntries(res.deleteentries);
                }

                if ("providermodul" in res)
                  store.methods.setProviderModule(res.providermodul);

                const response_check = await store.methods.apiRequest(
                  "getsessionstatus"
                );

                const res_c = response_check.data;

                if (res_c.errordetails) {
                  console.log("error", res_c.errordetails);
                }
                if (res_c.noticesfield) {
                  store.methods.setNoticesField(res_c.noticesfield);
                }

                if (res_c.providername) {
                  store.methods.setCustomerName(res_c.providername);
                }
                if (res.logintype == "mandate") {
                  router.push("/cleaning");
                } else if (res.logintype == "administrator") {
                  store.methods.setCustomerName("ADMINISTRATOR");
                  router.push("/users");
                } else {
                  router.push("/announcements");
                }
              }
            }
          }
        } else {
          return false;
        }
      });
    },
    cancel() {
      this.hasClients = false;
      this.clients = [];
      this.ruleForm.username = "";
      this.ruleForm.password = "";
      this.ruleFormClients.client = "";
    },
    selectClient(formName) {
      const store = this.$root.store;
      const router = this.$router;

      this.errors = "";

      this.$refs[formName].validate(async valid => {
        if (valid) {
          const response = await store.methods.apiRequest("selectmandate", {
            idmandate: this.ruleFormClients.client
          });
          const client = this.clients[this.ruleFormClients.client];

          if (!client) {
            this.$message({
              showClose: true,
              message: this.$t("client_not_found"),
              type: "error",
              offset: 350
            });

            this.cancel();

            return false;
          }

          const res = response.data;

          if (res.errordetails) {
            this.errors = res.errordetails;
          } else {
            if (res.status == "success") {
              store.methods.setLogin(true);
              store.methods.setCustomerName(client.name);
              store.methods.setLoginType("provider");

              if ("providermodul" in res)
                store.methods.setProviderModule(res.providermodul);

              const response_check = await store.methods.apiRequest(
                "getsessionstatus"
              );

              const res_c = response_check.data;

              if (res_c.errordetails) {
                console.log("error", res.errordetails);
              }

              if (res_c.providername) {
                store.methods.setCustomerName(res_c.providername);
              }
              if (res_c.noticesfield) {
                store.methods.setNoticesField(res_c.noticesfield);
              }

              router.push("/cleaning");
            }
          }
        } else {
          return false;
        }
      });
    }
  }
};
</script>
